/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

const seoMetaTagKeys = {
  title: 'title',
  description: 'metaDescription',
  author: 'metaAuthor',
  robots: 'metaRobots',
  ['og:title']: 'metaTitle',
  ['og:description']: 'metaOGDescription',
  ['og:url']: 'metaUrl',
  ['og:image']: 'metaImage',
  ['og:type']: 'metaType',
  ['og:site_name']: 'metaSiteName',
  canonical: 'linkCanonical',
  alternateUrl: 'linkAlternateUrl',
  shelfSchema: 'scriptShelfSchema',
  productSchema: 'scriptProductSchema',
  reviewsPageSchema: 'scriptReviewsPageSchema',
  articleSchema: 'scriptArticleSchema',
  videoSchema: 'scriptVideoSchema',
} as const;

export const metaTagKey = (key: keyof typeof seoMetaTagKeys) => seoMetaTagKeys[key];
